export default function IconUnlock(props: Icon) {
  const { height, width, className } = props;
  return (
    <svg
      className={`flex-shrink-0${className ? ` ${className}` : ""}`}
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 -960 960 960"
    >
      <path
        fill="currentColor"
        d="M242.87-72.587q-37.538 0-64.269-26.731-26.732-26.731-26.732-64.269v-394.261q0-37.537 26.732-64.269 26.731-26.731 64.269-26.731h349.717v-73.065q0-47.21-32.728-80.257Q527.13-835.217 480-835.217q-38.269 0-66.972 22.511-28.702 22.51-39.702 56.206-5.674 15.674-20.087 25.13-14.413 9.457-31.431 9.457-19.286 0-31.982-13.391-12.696-13.392-8.5-31.022Q297-834.609 352.12-880.413q55.119-45.805 127.88-45.805 84.674 0 144.13 59.696 59.457 59.696 59.457 144.609v73.065h33.543q37.538 0 64.269 26.731 26.732 26.732 26.732 64.269v394.261q0 37.538-26.732 64.269-26.731 26.731-64.269 26.731H242.87Zm0-91h474.26v-394.261H242.87v394.261ZM480-280.717q33 0 56.5-23.5t23.5-56.5q0-33-23.5-56.5t-56.5-23.5q-33 0-56.5 23.5t-23.5 56.5q0 33 23.5 56.5t56.5 23.5Zm-237.13 117.13v-394.261 394.261Z"
      />
    </svg>
  );
}
